import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const IntituteGradeForApproval = () => {
    const authorizedAxios = generateAxiosInstance()
    const [InstituteGradeList, setInstituteGradeList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [addNew, setAddNew] = useState(false);

    const [classSort, setClassSort] = useState(null);
    const [instituteSort, setInstituteSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["gradeName", "instituteGradeMasterDetails.instituteMasterDetails.instituteName", "instituteGradeMasterDetails.instituteMasterDetails.email"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getUnapprovedGrades();
    }, []);

    const getUnapprovedGrades = async () => {
        try {
            setLoading(true);
            let apiUrl = "/get-un-approved-grades";
            const response = await authorizedAxios.get(apiUrl);
            setInstituteGradeList(response.data.result);
        } catch (error) {
            setInstituteGradeList([]);
            console.log("Error fetching data: ", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getUnapprovedGrades();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setInstituteGradeList(await searchArray("A", "/get-un-approved-grades", searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(InstituteGradeList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(InstituteGradeList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > InstituteGradeList.length) {
            endIndex = InstituteGradeList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(InstituteGradeList.slice(startIndex, endIndex));
    }, [InstituteGradeList, currPage, itemsPerPage]);

    const changeActive = async (id) => {
        try {
            setLoading(true);
            const apiUrl = `/approve-institute-grades?id=${id}`;
            const response = await authorizedAxios.patch(apiUrl);
            Swal.fire({ text: response.data.message });
        } catch (error) {
            const errorMsg = error?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (classSort == true || classSort == false) {
            setInstituteSort(null);
            setEmailSort(null);
        }
    }, [classSort])

    useEffect(() => {
        if (instituteSort == true || instituteSort == false) {
            setClassSort(null);
            setEmailSort(null);
        }
    }, [instituteSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setClassSort(null);
            setInstituteSort(null);
        }
    }, [emailSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Institute Class Approve</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-graduation-cap"></i> Institute Class Approve</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Class Name
                                                                            <SortIcon sortState={classSort} setSortState={setClassSort} setData={setInstituteGradeList} setCurrPage={setCurrPage} sortingPath={"gradeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Institude Name
                                                                            <SortIcon sortState={instituteSort} setSortState={setInstituteSort} setData={setInstituteGradeList} setCurrPage={setCurrPage} sortingPath={"instituteGradeMasterDetails.instituteMasterDetails.instituteName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Institude Email
                                                                            <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setInstituteGradeList} setCurrPage={setCurrPage} sortingPath={"instituteGradeMasterDetails.instituteMasterDetails.email"} />
                                                                        </th>
                                                                        <th scope='col'>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((grade, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{grade?.gradeName}</td>
                                                                                        <td>{grade?.instituteGradeMasterDetails?.instituteMasterDetails?.instituteName}</td>
                                                                                        <td>{grade?.instituteGradeMasterDetails?.instituteMasterDetails?.email}</td>
                                                                                        <td>
                                                                                            <button className='btn btn-success approve_icon' onClick={() => changeActive(grade.id)}>Approve</button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Data Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={InstituteGradeList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default IntituteGradeForApproval
